import { keepPreviousData, useMutation, useQuery } from "@tanstack/react-query";

import {
  addCollaborator,
  getCollaborator,
  getCollaborators,
  updateCollaborator,
} from "@/api";
import type { CollaboratorType } from "@/types";

export interface CollaboratorsFilter {
  "filter[name]"?: string;
  "filter[type]"?: CollaboratorType;
}

export const collaboratorsQueryKeys = {
  useCollaborator: (id?: string) => ["collaborators", "getCollaborator", id],
  useCollaborators: (search?: string, type?: string) => [
    "collaborators",
    "getCollaborators",
    search,
    type,
  ],
};

export const useCollaborators = () => {
  const useCollaborator = (id?: string) =>
    useQuery({
      queryFn: () => getCollaborator(id!),
      queryKey: collaboratorsQueryKeys.useCollaborator(id),
      enabled: !!id,
    });

  const useAllCollaborators = (search?: string, type?: string) =>
    useQuery({
      queryFn: () => getCollaborators(search, type),
      queryKey: collaboratorsQueryKeys.useCollaborators(search, type),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
    });

  const useAddCollaborator = () =>
    useMutation({
      mutationFn: addCollaborator,
    });

  const useUpdateCollaborator = () =>
    useMutation({ mutationFn: updateCollaborator });

  return {
    useCollaborator,
    useAllCollaborators,
    useAddCollaborator,
    useUpdateCollaborator,
  };
};
